import {fetch} from "./fetch";
import url from './url';

export function queryListFromH5(data) {
    return fetch({
        url: url.queryListFromH5,
        method: 'post',
        data:data
    })
}

export function getNewsTab() {
    return fetch({
        url: url.getNewsTab,
        method: 'get',
    })
}

export function queryInfoFromH5(data) {
    return fetch({
        url: url.queryInfoFromH5,
        method: 'post',
        data:data
    })
}

export function queryNextOrPre(data) {
    return fetch({
        url: url.queryNextOrPre,
        method: 'post',
        data:data
    })
}